import React from 'react';

import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { useFormattedUser } from '@adsk/alloy-provider';
import { LockIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import Tooltip from '@adsk/alloy-react-tooltip';

const PackagesLockedIcon = (props) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { loading, formatDisplayUser } = useFormattedUser();

  return (
    <Tooltip
      shouldWrapChildren={false}
      content={T.translate('TABLE_COLUMN.LOCKED_TOOLTIP', {
        lockedBy: loading ? (
          <ProgressRing
            style={{ marginLeft: 4 }}
            size={ProgressRing.SIZES.XSMALL}
          />
        ) : (
          formatDisplayUser(props.lockedBy)?.displayName
        ),
        lockedAt: format(props.lockedAt, 'PP p'),
      })}
    >
      <LockIcon size={20} style={{ marginLeft: 4 }} />
    </Tooltip>
  );
};

PackagesLockedIcon.propTypes = {
  lockedBy: PropTypes.string,
  lockedAt: PropTypes.string,
};

export default PackagesLockedIcon;
